function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  className: "fil0",
  d: "M1787.27 1652.82c-74.34,-74.2 -499.09,-483.25 -521.45,-532.05l266.01 -263.46c90.92,-91 174.78,-174.82 265.66,-265.87 46.77,-46.86 443.82,-419.1 453.58,-476.01 8.47,-49.38 -40.68,-206.97 -204.98,-42.03l-393.52 393.55c-74.21,74.26 -483.48,499.42 -532.01,521.57l-794.91 -797.56c-37.04,-37.06 -161.73,-179.45 -210.29,-187.72 -49.65,-8.46 -203.31,43.54 -46.86,199.53 152.56,152.11 900.58,888.81 919.89,930.94l-930.3 928.01c-21.4,21.15 -48.52,38.56 -55.19,77.12 -8.38,48.5 38.77,209.05 205.21,42.22 152.31,-152.66 883.43,-895.84 925.46,-915.11l794.99 797.56c46.66,46.73 86.14,86.04 132.77,133 20.17,20.31 40.06,48.63 77.29,54.89 42.28,7.1 212.13,-34.9 42.15,-205.02l-393.51 -393.56z"
}));

var SvgCloseNew = function SvgCloseNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "3.06379in",
    height: "3.06405in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2254.88 2255.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close_new.c22d225a.svg";
export { ForwardRef as ReactComponent };